angular.module('agreements')
    .component('agreementBgt', {
        bindings: {
            agreementId: '<',
            totalNet: '<',
            currency: '<',
        },
        templateUrl: 'app/agreements/bgt/agreement-bgt.html',
        controller: function ($scope, InvoiceService, AgreementBgt, AgreementBgtService, AgreementConst, Principal, BgtGroupingService, modals, toastr) {
            this.AgreementBgtService = AgreementBgtService

            this.$onInit = () => {
                this.canEditContractBgt = Principal.hasAnyAuthority(['ROLE_CONTRACT_BGT_WRITE', 'ROLE_ADMIN'])
            }

            this.$onChanges = () => {
                this.canEditContractBgt = Principal.hasAnyAuthority(['ROLE_CONTRACT_BGT_WRITE', 'ROLE_ADMIN'])
                this.loadRevisions()
            }

            this.loadRevisions = () => {
                return AgreementBgt.revisions({agreementId: this.agreementId}).$promise.then(revisions => {
                    this.revisions = revisions
                    this.hasDraft = revisions.some(revision => revision.status === 'DRAFT')
                    this.selectedRevision = this.canEditContractBgt ? revisions.find(revision => revision.status === 'DRAFT') : null
                    this.selectedRevision = this.selectedRevision || revisions.find(revision => revision.status === 'ACTIVE') || revisions[0] || null
                    return this.loadItems()
                })
            }
            this.loadItems = () => {
                const params = {agreementId: this.agreementId}
                if (this.selectedRevision) {
                    params.revisionId = this.selectedRevision.id
                }
                return AgreementBgt.query(params).$promise.then(result => {
                    this.items = result;
                    this.processGrouped();
                })
            }
            this.selectRevision = revision => {
                this.selectedRevision = revision
                return this.loadItems()
            }
            this.selectDraft = () => {
                const draft = this.revisions.find(revision => revision.status === 'DRAFT')
                if (draft) {
                    return this.selectRevision(draft)
                }
            }
            this.isRevisionSelected = revision => this.selectedRevision && revision.id === this.selectedRevision.id
            this.isDraftSelected = () => this.selectedRevision && this.selectedRevision.status === 'DRAFT'
            this.isInitialRevision = () => this.selectedRevision && this.selectedRevision.revisionNumber === 1
            this.isCommentRequired = () => !this.isInitialRevision()
            this.revisionStatusLabel = revision => ({DRAFT: 'Robocza', ACTIVE: 'Aktualna', ARCHIVED: 'Archiwalna'})[revision.status]
            this.createRevision = () => {
                if (this.creatingRevision) {
                    return
                }
                this.creatingRevision = true
                return AgreementBgt.createRevision({agreementId: this.agreementId}, {}).$promise
                    .then(() => this.loadRevisions())
                    .catch(() => toastr.error('Nie udało się utworzyć wersji roboczej BGT'))
                    .finally(() => this.creatingRevision = false)
            }
            this.publishRevision = () => {
                if (!this.isDraftSelected() || (this.isCommentRequired() && (!this.selectedRevision.comment || !this.selectedRevision.comment.trim()))) {
                    toastr.error('Opis wersji jest wymagany')
                    return
                }
                return modals.confirm('Czy zapisać wersję BGT <strong>' + this.selectedRevision.revisionNumber + '</strong> jako aktualną?', () => AgreementBgt.publishRevision({agreementId: this.agreementId, revisionId: this.selectedRevision.id}, {version: this.selectedRevision.version, comment: this.selectedRevision.comment || null}).$promise).then(() => this.loadRevisions())
            }
            this.discardRevision = () => modals.confirmDelete('wersję roboczą BGT', () => AgreementBgt.deleteRevision({agreementId: this.agreementId, revisionId: this.selectedRevision.id}).$promise).then(() => this.loadRevisions())

            this.add = () => {
                AgreementBgtService.add(this.agreementId, this.selectedRevision.id, this.totalLeft, this.totalNet, this.currency).then(() => this.loadRevisions())
            }

            this.edit = (item) => {
                AgreementBgtService.edit(this.agreementId, this.selectedRevision.id, item, this.totalLeft, this.totalNet, this.currency).then(() => this.loadRevisions())
            }

            this.delete = (item) => {
                AgreementBgtService.delete(this.agreementId, this.selectedRevision.id, item).then(() => this.loadRevisions())
            }

            this.getGroupTotal = (grouped) => {
                return BgtGroupingService.sumGroupAmounts(grouped);
            }

            this.processGrouped = () => {
                this.groupedItems = BgtGroupingService.groupItemsByParent(this.items);
                this.total = BgtGroupingService.sumAmounts(this.items);
                this.totalLeft = (this.totalNet != null)? InvoiceService.sub(this.totalNet, this.total) : null;
            };

            $scope.$on(AgreementConst.eventUpdate, () => this.loadRevisions())
        }
    })
